<template>
  <el-drawer
    :title="`网关黑名单列表 - ${currentGateway.name || ''} - ${currentGateway.macAddr || ''}`"
    :visible.sync="drawerVisible"
    direction="rtl"
    :wrapperClosable="true"
    size="30%"
  >
    <div v-loading="loading" class="blacklist-drawer-content">
      <div class="drawer-header">
        <div class="header-left">
          <el-button
            type="danger"
            size="mini"
            @click="handleBatchDelete"
            :disabled="selectedRows.length === 0"
          >
            批量移除黑名单<span v-if="selectedRows.length > 0" class="selected-count"> ( {{ selectedRows.length }} )</span>
          </el-button>
        </div>
        <div class="header-right">
          <span class="total-count">总条数: <strong>{{ blacklistDetailData.length }}</strong> 条</span>
        </div>
      </div>
      <el-table
        ref="blacklistTable"
        :data="blacklistDetailData"
        border
        size="small"
        max-height="700"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column
          label="字典项名称"
          prop="itemName"
          align="center"
        ></el-table-column>
        <el-table-column
          label="字典项编码"
          prop="itemCode"
          align="center"
        ></el-table-column>
        <el-table-column
          label="字典项值"
          prop="itemValue"
          align="center"
        ></el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="150"
        >
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="small"
              @click="handleRemove(row)"
              :loading="deletingId === row.id"
            >
              移除黑名单
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-drawer>
</template>

<script>
import { loadGatewayElectricBlack, loadPhysicalDelete } from "@/api/waveform/gateway";

export default {
  name: "BlacklistDetailDrawer",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    currentGateway: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      blacklistDetailData: [],
      deletingId: null,
      selectedRows: [],
      drawerVisible: false,
    };
  },
  watch: {
    visible(newVal) {
      this.drawerVisible = newVal;
      if (newVal && this.currentGateway && this.currentGateway.id) {
        this.fetchBlacklistDetail(this.currentGateway.id);
      }
    },
    currentGateway(newVal) {
      if (this.drawerVisible && newVal && newVal.id) {
        this.fetchBlacklistDetail(newVal.id);
      }
    },
  },
  methods: {
    fetchBlacklistDetail(gatewayId) {
      this.loading = true;
      loadGatewayElectricBlack(gatewayId)
        .then((res) => {
          this.loading = false;
          if (res.code === 200) {
            this.blacklistDetailData = res.data || [];
          } else {
            this.$message.error(res.msg || "获取黑名单详情失败");
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error("获取黑名单详情失败:", error);
          this.$message.error("获取黑名单详情失败，请稍后重试");
        });
    },
    deleteBlacklistItem(row) {
      this.deletingId = row.id;
      const requestData = {
        dictItemIdList: [row.dictItemId],
        gatewayIdList: [this.currentGateway.id],
      };

      return loadPhysicalDelete(requestData)
        .then((res) => {
          this.deletingId = null;
          if (res.code === 200) {
            return Promise.resolve();
          } else {
            this.$message.error(res.msg || "移除失败");
            return Promise.reject(new Error(res.msg || "移除失败"));
          }
        })
        .catch((error) => {
          this.deletingId = null;
          console.error("移除黑名单失败:", error);
          return Promise.reject(error);
        });
    },
    updateBlackCount() {
      // 获取最新的黑名单数量
      loadGatewayElectricBlack(this.currentGateway.id)
        .then((res) => {
          if (res.code === 200) {
            const newBlackCount = res.data ? res.data.length : 0;
            this.$emit("update-black-count", {
              gatewayId: this.currentGateway.id,
              blackCount: newBlackCount,
            });
          }
        })
        .catch((error) => {
          console.error("获取黑名单数量失败:", error);
        });
    },
    handleRemove(row) {
      this.$confirm("确定要移除该黑名单项吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteBlacklistItem(row)
            .then(() => {
              this.$message.success("移除成功");
              this.updateBlackCount();
              this.$emit("refresh-table");
              this.fetchBlacklistDetail(this.currentGateway.id);
            });
        })
        .catch(() => {
          // 用户取消操作或删除失败
        });
    },
    handleSelectionChange(rows) {
      this.selectedRows = rows;
    },
    handleBatchDelete() {
      if (this.selectedRows.length === 0) {
        this.$message.warning("请先选择要移除的黑名单项");
        return;
      }
      this.$confirm(
        `确定要移除选中的 ${this.selectedRows.length} 个黑名单项吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          const deletePromises = this.selectedRows.map((row) =>
            this.deleteBlacklistItem(row)
          );

          Promise.all(deletePromises)
            .then(() => {
              this.$message.success("批量移除成功");
              this.updateBlackCount();
              this.$emit("refresh-table");
              this.$refs.blacklistTable.clearSelection();
              this.selectedRows = [];
              this.fetchBlacklistDetail(this.currentGateway.id);
            })
            .catch(() => {
              // 错误已在 deleteBlacklistItem 中处理
            });
        })
        .catch(() => {
          this.$message.info("已取消移除");
        });
    },
  },
};
</script>

<style scoped>
.blacklist-drawer-content {
  padding: 20px;
}
.el-table >>> .el-table__header-wrapper .el-table__header th {
  background-color: #fafafa;
}
.drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebeef5;
}
.header-left {
  flex: 0 0 auto;
}
.header-right {
  flex: 0 0 auto;
}
.total-count {
  font-size: 14px;
  color: #606266;
}
.total-count strong {
  color: #00d8c3;
  font-size: 16px;
  margin-left: 5px;
}
.selected-count {
  font-weight: bold;
}
</style>
